module.exports = __webpack_public_path__ + "img/urun-alt.b8d233f6.jpg";